exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-shadow[data-v-724b0dbc] {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n", ""]);

// exports
